<template>
	<!-- Edit Config Modal -->
		<div class="modal fade show" id="modal-default" tabindex="-1" style="display: block;" aria-modal="true">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Edit Description</h5><i class="modal-close zwicon-close pull-right display-4" @click='close'></i>
					</div> 
					<div class="modal-body">
						<table id="data-table" class="table dataTable no-footer" role="grid" aria-describedby="data-table_info">
                            <tbody class="table-dark">
                                <tr role="row">
                                    <th colspan="1"><label for="temp-item-serialno">Description Name</label></th>
                                    <td colspan="3"> 
                                        <div class="form-group mb-0">
                                            <input id="temp-item-serialno" class="form-control" v-model='this.temp_item_name'>
                                        </div>
                                    </td>
								</tr>
								<tr role="row">
                                    <th colspan="1"><label for="temp-item-category">Category</label></th>
                                    
                                    <td colspan="3">
                                        <div class="form-group mb-0">
                                            <select id="temp-item-category" class="form-control" v-model='this.temp_parent_id'>
                                                <option value="false">-</option>
                                                <option v-for="category in category_list.list" v-bind:key="category" :value="category.configuration_id">{{category.name}}</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
					</div>
					<ErrorMessage :message='error' v-if='error.length > 0' />
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click='action'><i class="zwicon-plus"></i> Edit Description</button>
                    </div>
				</div>
			</div>
		</div>
		<!-- End Add Item Modal -->
</template>

<script>
	import PermissionService from "@/common/permission.service";

    import { mapGetters } from "vuex";
	import ErrorMessage from "@/components/General/ErrorMessage";
    import store from "@/store";

	import { EDIT_CATEGORY_ENTRY } from "@/store/actions.type";

	export default {
		name: 'EditDescription',
		components: {
			ErrorMessage
		},
		props: {
            item: {},
        },
		data(){
			return {
				error: '',
                id: '',
				temp_item_name: '',
				temp_item_category: '',
                temp_item_id: '',
				temp_parent_id: null
			};
		},
        mounted(){
            this.temp_item_id = this.item.configuration_id;
			this.temp_item_name = this.item.name;
			this.temp_parent_id = this.item.parent_configuration_id;
        },
        computed: {
            new_item(){
                return {
                    'category_id': this.temp_item_id,
                    'parent_id': this.temp_parent_id,
                    'name': this.temp_item_name
                }
            },
            ...mapGetters(['user', 'loading', 'category_list', 'description_list'])
        },
		methods: {
			getPermission(category, permission){
				return PermissionService.getPermission(category, permission);
			},
			get_error(key){
				if(this.errors[key] !== undefined) return this.errors[key];
				return '';
			},
			close(){
				this.$emit('close');
			},
			action(){
				store.dispatch(EDIT_CATEGORY_ENTRY, this.new_item).then(() => {
                    
                    this.$emit('edited',this.new_item);
				}).catch(message => {
					console.log(message);
				}).finally(() => {
					
				});
                
				
			},
		}
	}
</script>